import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import * as React from 'react';
import * as PropTypes from 'prop-types';
import Portal from '../core/Portal';
import { isFunction } from '@utiljs/is';
import createRef from '@roo/create-react-ref/createRef';
import { contains } from '@utiljs/dom';
import omit from 'lodash/omit';
import { disableBodyScroll, enableBodyScroll } from '../_utils/Dom'; // 105 是为了减去阴影的影响

var transforms = {
  top: 'translateY(-105%)',
  right: 'translateX(105%)',
  bottom: 'translateY(105%)',
  left: 'translateX(-105%)'
};

var Drawer = /*#__PURE__*/function (_React$Component) {
  _inherits(Drawer, _React$Component);

  var _super = _createSuper(Drawer);

  function Drawer() {
    var _this;

    _classCallCheck(this, Drawer);

    _this = _super.apply(this, arguments);
    _this.contentRef = createRef();
    _this.portalRef = createRef();

    _this.handleFocus = function () {
      var visible = _this.props.visible;

      if (visible && _this.portalRef && _this.portalRef.current) {
        _this.portalRef.current.focus();
      }
    };

    _this.handleClickOutside = function (event) {
      var visible = _this.props.visible;

      if (!visible) {
        return;
      }

      var _this$props = _this.props,
          onClickOutside = _this$props.onClickOutside,
          onClose = _this$props.onClose;
      var domNode = _this.contentRef.current;
      var portalNode = _this.portalRef.current; // React-portal agents event，so DOM should be in portal-dom

      if ((!domNode || !contains(domNode, event.target)) && contains(portalNode, event.target)) {
        if (isFunction(onClickOutside)) {
          onClickOutside();
        }

        if (isFunction(onClose)) {
          onClose();
        }
      }
    };

    _this.handleESC = function (event) {
      var visible = _this.props.visible;

      if (!visible) {
        return;
      }

      if (event.keyCode === 27) {
        var _this$props2 = _this.props,
            onClose = _this$props2.onClose,
            onESC = _this$props2.onESC;
        event.stopPropagation();

        if (isFunction(onESC)) {
          onESC();
        }

        if (isFunction(onClose)) {
          onClose();
        }
      }
    };

    _this.handleTransitionEnd = function (event) {
      if (event.target === _this.contentRef.current && event.propertyName.match(/transform$/)) {
        var _this$props3 = _this.props,
            onOpened = _this$props3.onOpened,
            onClosed = _this$props3.onClosed,
            visible = _this$props3.visible;

        if (isFunction(onOpened) && visible) {
          onOpened();
        }

        if (isFunction(onClosed) && !visible) {
          onClosed();
        }
      }
    };

    return _this;
  }

  _createClass(Drawer, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prveProps) {
      var _this$props4 = this.props,
          visible = _this$props4.visible,
          scrollable = _this$props4.scrollable;

      if (visible !== prveProps.visible && visible) {
        this.handleFocus();
      }

      if (visible && !scrollable) {
        disableBodyScroll();
      } else {
        enableBodyScroll();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.visible) {
        enableBodyScroll();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _contentStyle;

      var _a = this.props,
          zIndex = _a.zIndex,
          popupContainer = _a.popupContainer,
          width = _a.width,
          placement = _a.placement,
          children = _a.children,
          backdrop = _a.backdrop,
          visible = _a.visible,
          height = _a.height,
          style = _a.style,
          duration = _a.duration,
          backdropClassName = _a.backdropClassName,
          backdropPropsStyle = _a.backdropStyle,
          restProps = __rest(_a, ["zIndex", "popupContainer", "width", "placement", "children", "backdrop", "visible", "height", "style", "duration", "backdropClassName", "backdropStyle"]);

      var backdropStyle = {};
      var portalStyle = {
        zIndex: zIndex
      };
      var drawerStyle = {};

      if (!visible) {
        backdropStyle = {
          width: 0,
          opacity: 0
        };
        portalStyle = {
          width: 0,
          zIndex: zIndex
        };
        drawerStyle = {
          transform: transforms[placement || 'left']
        };
      }

      var contentStyle = (_contentStyle = {
        width: placement === 'left' || placement === 'right' ? width : '100%',
        height: placement === 'top' || placement === 'bottom' ? height : '100%',
        transition: "transform ".concat(duration, "ms cubic-bezier(0.7,0,0.3,1) 0ms")
      }, _defineProperty(_contentStyle, placement || 'left', 0), _defineProperty(_contentStyle, "zIndex", 1000), _contentStyle);
      var restDomProps = omit(restProps, ['onClickOutside', 'onESC', 'onClose', 'onClosed', 'onOpened', 'scrollable']);
      return /*#__PURE__*/React.createElement(Portal, {
        container: popupContainer
      }, /*#__PURE__*/React.createElement("div", {
        tabIndex: -1,
        onClick: this.handleClickOutside,
        onKeyDown: this.handleESC,
        ref: this.portalRef,
        className: "roo-drawer-portal",
        style: _Object$assign({}, portalStyle)
      }, backdrop && /*#__PURE__*/React.createElement("div", {
        className: "roo-backdrop",
        style: _Object$assign(_Object$assign({}, backdropPropsStyle), backdropStyle)
      }), /*#__PURE__*/React.createElement("div", _Object$assign({
        className: "roo-drawer",
        onTransitionEnd: this.handleTransitionEnd,
        ref: this.contentRef,
        style: _Object$assign(_Object$assign(_Object$assign({}, style), contentStyle), drawerStyle)
      }, restDomProps), children)));
    }
  }]);

  return Drawer;
}(React.Component);

Drawer.defaultProps = {
  width: '300px',
  height: '256px',
  placement: 'left',
  backdrop: true,
  duration: 300,
  scrollable: true,
  backdropStyle: undefined,
  backdropClassName: undefined,
  zIndex: 1000
};
Drawer.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  placement: PropTypes.oneOf(['left', 'right', 'top', 'bottom']),
  backdrop: PropTypes.bool,
  scrollable: PropTypes.bool,
  duration: PropTypes.number,
  zIndex: PropTypes.number,
  backdropStyle: PropTypes.object,
  backdropClassName: PropTypes.string
};
export default Drawer; // TIPS:
// tabIndex 照理应该在 content 上，但是会出现动画抖动的问题。